import React from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// "Ada Lovelace" -> "AL"
const initialsOf = (name = "") =>
  name.trim().split(/\s+/).slice(0, 2).map((p) => p[0] || "").join("").toUpperCase() || "?";

const RecentThreads = ({ Threads, dataLoading }) => {
  const navigate = useNavigate();

  const handleRowClick = (thread) => {
    navigate("/chats", { state: { NotificationThreadId: thread.id } });
  };

  // Text only. DOMParser builds an inert document: unlike innerHTML on a
  // detached element, nothing in it runs or loads (an <img onerror> would).
  const preview = (message) =>
    (new DOMParser().parseFromString(message || "", "text/html").body.textContent || "").trim();

  return (
    <div className="dashboard__card feed-card">
      <div className="feed-card__header">
        <h5 className="dashboard__card__title">Recent chats</h5>
        {Threads.length > 0 && (
          <button type="button" className="btn btn-sm btn-link feed-card__all" onClick={() => navigate("/chats")}>
            See all chats
          </button>
        )}
      </div>

      {dataLoading ? (
        <ul className="feed-card__list">
          {Array.from({ length: 5 }).map((_, i) => (
            <li key={i} className="feed-card__item">
              <Skeleton circle width={36} height={36} />
              <div className="flex-grow-1">
                <Skeleton width="40%" height={12} />
                <Skeleton width="85%" height={12} />
              </div>
            </li>
          ))}
        </ul>
      ) : Threads.length === 0 ? (
        <div className="feed-card__empty">
          <p className="mb-2">No conversations yet.</p>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => navigate("/chats")}>
            Message the ADM team
          </button>
        </div>
      ) : (
        <ul className="feed-card__list">
          {Threads.map((thread) => {
            const fromTeam = thread.lastMessageSenderCompany === "ADM Team";
            return (
              <li
                key={thread.id}
                className="feed-card__item clickable"
                onClick={() => handleRowClick(thread)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleRowClick(thread)}
                role="link"
                tabIndex={0}
              >
                <span className={`feed-card__avatar ${fromTeam ? "is-team" : ""}`} aria-hidden="true">
                  {initialsOf(thread.lastMessageSender)}
                </span>
                <div className="feed-card__text">
                  <div className="feed-card__line">
                    <span className="feed-card__who">
                      {thread.lastMessageSender || "Unknown"}
                      {thread.lastMessageSenderCompany && (
                        <span className="feed-card__org"> · {thread.lastMessageSenderCompany}</span>
                      )}
                    </span>
                    <span className="feed-card__time">{thread.lastMessageTime}</span>
                  </div>
                  <div className="feed-card__preview">{preview(thread.lastMessage) || "—"}</div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default RecentThreads;
